import React from 'react';

import globalsService from '../../../services/GlobalsService';
import { t } from '../../../services/i18nService';

import styles from './idcard.scss';

class IdCardRectangle extends React.PureComponent {
    render() {
        const assetRoot = globalsService.getAssetRoot();
        let idCardRectanglePath = 'images/idverification/id-card-rectangle-pink.svg';

        if (assetRoot) {
            idCardRectanglePath = `${assetRoot}/${idCardRectanglePath}`;
        }

        return (
            <div className={styles.idCardRectangle}>
                <div className={styles.idCardRectanglePositioner}>
                    <img
                        src={idCardRectanglePath}
                        alt={t('idVerification.idCard.idCardRectangleAltText')}
                        className={styles.idCardRectangleShape}
                    />
                </div>
            </div>
        );
    }
}

export default IdCardRectangle;
